// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"1754d157","129":"538d39e3","454":"53360445"}[chunkId] + ".chunk.js";
};